import { createSlice } from '@reduxjs/toolkit';
import {fetchData, showError, setPresets, presetEdited, presetDeleted} from "./coreSlice";
import axios from '../axios-pogo';
import {push} from 'connected-react-router';

export const StopOverlayTypes = {
	NONE: 0,
	LURE: 1,
	QUEST: 2,
	GRUNT: 3,
};

export const StopQuestLevels = {
	ALL: 0,
	GOOD: 1,
	BEST: 2,
};

export const StopGruntLevels = {
	ALL: 0,
	ONLY_LEADERS: 1,
	ONLY_GRUNTS: 2,
	ONLY_GIOVANNI: 3,
};

export const GymMembershipTypes = {
	ALL: 0,
	AM_MEMBER: 1,
	AM_NOT_MEMBER: 2,
}

const filterSlice = createSlice({
	name: 'filter',
	initialState: {
		showPokemon: true,
		showRaids: false,
		showStops: false,
		showGyms: false,
		showSpawnpoints: false,

		goldBadge: 0,
		gymTeam: 0,
		gymStagnationDays: 0,
		gymOpenSpotsOnly: false,
		gymExFilter: false,
		gymMembership: GymMembershipTypes.ALL,

		raidLevel1: true,
		raidLevel2: true,
		raidLevel3: true,
		raidLevel4: true,
		raidLevel5: true,
		raidLevel6: true,
		raidExFilter: false,

		stopOverlay: StopOverlayTypes.QUEST,
		stopLureOnlySpecial: false,
		stopQuestLevel: StopQuestLevels.GOOD,
		stopGruntLevel: StopGruntLevels.ALL,
		stopShowAll: false,

		pokemonQuality: 20,
		pokemonSpecies: [],
	},
	reducers: {
		setFeature(state, action) {
			state[action.payload.id] = action.payload.value;
		},


		setPokemonQuality(state, action) { state.pokemonQuality = +action.payload },
		addPokemonSpecies(state, action) { state.pokemonSpecies.push(+action.payload); },
		removePokemonSpecies(state, action) { state.pokemonSpecies = state.pokemonSpecies.filter(p => p !== +action.payload); },
		clearPokemonSpecies(state) { state.pokemonSpecies = []; },

		setGoldBadge(state, action) { state.goldBadge = +action.payload },
		setGymTeam(state, action) { state.gymTeam = +action.payload },
		setGymStagnationDays(state, action) { state.gymStagnationDays = +action.payload },
		setGymOpenSpotsOnly(state, action) { state.gymOpenSpotsOnly = !!action.payload },
		setGymExFilter(state, action) { state.gymExFilter = !!action.payload },
		setGymMembership(state, action) { state.gymMembership = action.payload },

		setRaidLevel1(state, action) { state.raidLevel1 = action.payload; },
		setRaidLevel2(state, action) { state.raidLevel1 = action.payload; },
		setRaidLevel3(state, action) { state.raidLevel1 = action.payload; },
		setRaidLevel4(state, action) { state.raidLevel1 = action.payload; },
		setRaidLevel5(state, action) { state.raidLevel1 = action.payload; },
		setRaidLevel6(state, action) { state.raidLevel6 = action.payload; },
		setRaidExFilter(state, action) { state.raidExFilter = action.payload; },

		setStopOverlay(state, action) { state.stopOverlay = action.payload; },
		setStopQuestLevel(state, action) { state.stopQuestLevel = action.payload; },
		setStopGruntLevel(state, action) { state.stopGruntLevel = action.payload; },
		setStopShowAll(state, action) { state.stopShowAll = action.payload; },

		setFilters(state, action) {
			// Unpacks from saved settings
			const filters = typeof action.payload === 'string' ? JSON.parse(action.payload) : action.payload;
			// console.log("Set filters: ", action.payload, filters);
			const bools = ['showPokemon', 'showRaids', 'showStops', 'showGyms', 'showSpawnpoints', 'gymOpenSpotsOnly', 'gymExFilter',
				'raidLevel1', 'raidLevel2', 'raidLevel3', 'raidLevel4', 'raidLevel5', 'raidLevel6', 'raidExFilter',
				'stopLureOnlySpecial', 'stopShowAll'];
			const nums = ['goldBadge', 'gymTeam', 'stopOverlay', 'stopQuestLevel', 'stopGruntLevel', 'pokemonQuality', 'gymStagnationDays', 'gymMembership'];

			bools.forEach(field => {
				if( field in filters )
					state[field] = !!filters[field];
			});
			nums.forEach(field => {
				if( field in filters )
					state[field] = +filters[field];
			});
			if( 'pokemonSpecies' in filters )
				state.pokemonSpecies = filters['pokemonSpecies']; // TODO: validate
		}
	}
});

export const { setFeature,
	setPokemonQuality, addPokemonSpecies, removePokemonSpecies, clearPokemonSpecies,
	setGoldBadge, setGymOpenSpotsOnly, setGymTeam, setGymStagnationDays, setGymExFilter, setGymMembership,
	setRaidExFilter, setRaidLevel1, setRaidLevel2, setRaidLevel3, setRaidLevel4, setRaidLevel5, setRaidLevel6,
	setStopOverlay, setStopQuestLevel, setStopGruntLevel, setStopShowAll, setFilters
} = filterSlice.actions;

export const setShowGyms = (val) => {
	return (dispatch, getState) => {
		const state = getState();
		dispatch(setFeature({id: 'showGyms', value: val}));
		if( val && !state.filter.showGyms )
			dispatch(fetchData(false));
	}
};

export const setShowPokemon = (val) => {
	return (dispatch, getState) => {
		const state = getState();
		dispatch(setFeature({id: 'showPokemon', value: val}));
		if( val && !state.filter.showPokemon )
			dispatch(fetchData(false));
	}
};

export const setShowRaids = (val) => {
	return (dispatch, getState) => {
		const state = getState();
		dispatch(setFeature({id: 'showRaids', value: val}));
		if( val && !state.filter.showRaids )
			dispatch(fetchData(false));
	}
};

export const setShowStops = (val) => {
	return (dispatch, getState) => {
		const state = getState();
		dispatch(setFeature({id: 'showStops', value: val}));
		if( val && !state.filter.showStops )
			dispatch(fetchData(false));
	}
};

export const toggleFeature = (feature) => {
	return (dispatch, getState) => {
		const state = getState();
		const newVal = !state.filter[feature];
		dispatch(setFeature({id: feature, value: newVal}));
	}
};

export const savePreset = (name) => {
	return (dispatch, getState) => {
		const state = getState();
		axios.post('/mod/pokemon/map/ajax/presets.php', {
			filters: JSON.stringify(state.filter),
			name: name
		}).then(result => {
			console.log("Got save preset result: ", result.data);
			const newPresets = [result.data, ...state.core.presets];
			dispatch(setPresets(newPresets));
			dispatch(push(result.data.path));
		}).catch(error => {
			console.log("Error saving filter: ", error);
			dispatch(showError("Error saving filter. Please refresh page."));
		});
	};
};

export const editPreset = (preset) => {
	return (dispatch, getState) => {
		axios.post('/mod/pokemon/map/ajax/presets.php', preset).then(result => {
			dispatch(presetEdited(preset));
		}).catch(error => {
			console.log("Error saving preset: ", preset, error);
			dispatch(showError("Error saving preset. Please refresh page."));
		});
	}
};


export const deletePreset = (presetId) => {
	return (dispatch, getState) => {
		axios.post('/mod/pokemon/map/ajax/presets.php', {
			delete: presetId
		}).then(result => {
			dispatch(presetDeleted(presetId));
		}).catch(error => {
			console.log("Error deleting preset: ", presetId, error);
			dispatch(showError("Error deleting preset. Please refresh page."));
		});
	}
};

export const fetchPreset = (filterId) => {
	return (dispatch, getState) => {
		axios.post('/mod/pokemon/map/ajax/presets.php', {
			filter_id: filterId
		}).then(result => {
			console.log("Got fetch preset result: ", result.data);
			dispatch(setFilters(result.data.filters));
			dispatch(fetchData(false));
		}).catch(error => {
			console.log("Error fetching preset: ", filterId, error);
			dispatch(showError("Error fetching preset. Please refresh page."));
		});
	};
};

export default filterSlice.reducer;